export const HandleSelectBrowser = (url: string, browser: string) => {
    const isAndroid = /android/i.test(navigator.userAgent)
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)
    const isSamsungBrowser = /samsung/i.test(navigator.userAgent)
    const isNaverBrowser = /naver/i.test(navigator.userAgent)

    const isChrome = isIOS
        ? /crios/i.test(navigator.userAgent)
        : /chrome/i.test(navigator.userAgent) &&
        !isSamsungBrowser &&
        !isNaverBrowser

    const intentUrl = url.replace(/^https?:\/\//, '')

    const intentUrls = {
        Samsung: `intent://${intentUrl}#Intent;scheme=https;package=com.sec.android.app.sbrowser;S.browser_fallback_url=${encodeURIComponent(url)};end`,
        Naver: `intent://inappbrowser?url=${encodeURIComponent(url)}&version=1#Intent;scheme=naversearchapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.search;end;`,
        Chrome: `intent://${intentUrl}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`,
    }

    const iosUrls = {
        Chrome: `googlechrome://${url.replace(/^https?:\/\//, '')}`,
        Naver: `naversearchapp://inappbrowser?url=${encodeURIComponent(url)}`,
    }

    if (isChrome && browser === 'Chrome') {
        window.open(url, '_blank')
        return
    }

    if (isSamsungBrowser && browser === 'Samsung') {
        window.open(url, '_blank')
        return
    }

    if (isNaverBrowser && (browser === 'Naver' || browser === 'Default' || browser === 'Samsung' || browser === 'Safari')) {
        if (isAndroid) {
            window.open(intentUrls['Chrome'],'_blank')
        } else if (isIOS) {
            window.open(iosUrls['Naver'],'_blank')
        }
        return
    }

    if (isAndroid) {

        const selectedintentUrl = intentUrls[browser as keyof typeof intentUrls] || url
        window.open(selectedintentUrl, '_blank')

        if (isNaverBrowser) {
            window.open( intentUrls['Naver'])
        } else {
            setTimeout(() => {
                window.open(url, '_blank')
            }, 1000);
        }

    } else if (isIOS) {

        const selectedIosUrl = iosUrls[browser as keyof typeof iosUrls] || url
        window.open(selectedIosUrl, '_blank')

        if (isNaverBrowser) {
            window.open(iosUrls['Naver'])
        } else {
            setTimeout(() => {
                window.open(url, '_blank')
            }, 1000);
        }

    } else {
        window.open(url, '_blank')
    }
}
